const FILE_TYPE_MIME_TYPE_MAPPING = {
  // PDF
  'application/pdf': 'pdf',

  // Word Documents
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',

  // Text Files
  'text/plain': 'txt',

  // Markdown
  'text/markdown': 'md',

  // PowerPoint Presentations
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'pptx',

  // Excel Files
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
};

const getMimeTypeFromFileType = (fileType: string) => {
  const mimeType =
    FILE_TYPE_MIME_TYPE_MAPPING[
      fileType as keyof typeof FILE_TYPE_MIME_TYPE_MAPPING
    ];
  return mimeType || null;
};

const getFileTypeFromMimeType = (mimeType: string) => {
  const fileType = Object.keys(FILE_TYPE_MIME_TYPE_MAPPING).find(
    (key) =>
      FILE_TYPE_MIME_TYPE_MAPPING[
        key as keyof typeof FILE_TYPE_MIME_TYPE_MAPPING
      ] === mimeType
  );
  return fileType || null;
};

export {
  FILE_TYPE_MIME_TYPE_MAPPING,
  getMimeTypeFromFileType,
  getFileTypeFromMimeType,
};
